/** The backend owns the complete atomic delete. Never mutate counterparts or
 * the local trash before/after it: the committed host/root updates sync back. */
import { toast } from '@affine/component';
import { databasePermanentlyDeleteMutation } from '@affine/graphql';
import { I18n } from '@affine/i18n';

import type { GraphQLService } from '../../cloud';
import type { Workspace } from '../../workspace';
import type {
  DatabaseDiscoveryService,
  DatabaseInfo,
} from './database-discovery';

export type PermanentDatabaseDeleteOutcome = 'deleted' | 'server-failed';
export interface PermanentDatabaseDeleteContext {
  workspace: Workspace;
  graphql: GraphQLService;
  discovery: DatabaseDiscoveryService;
}

export async function permanentlyDeleteDatabase(
  ctx: PermanentDatabaseDeleteContext,
  database: DatabaseInfo
): Promise<PermanentDatabaseDeleteOutcome> {
  try {
    await ctx.workspace.engine.doc.flushAndWaitForSynced(database.docId);
    await ctx.graphql.gql({
      query: databasePermanentlyDeleteMutation,
      variables: {
        input: {
          workspaceId: ctx.workspace.id,
          docId: database.docId,
          blockId: database.blockId,
        },
      },
    });
    ctx.discovery.refresh();
    return 'deleted';
  } catch (error) {
    console.error('[DatabasePermanentDelete] Atomic delete failed:', error);
    toast(
      I18n.t('com.streamlain.streamlain.database-delete.server-failed', {
        error: error instanceof Error ? error.message : String(error),
      })
    );
    return 'server-failed';
  }
}
